import { z } from 'zod';

import { optionalString, requiredString } from '@/shared/utils/validation';

export const createResourceGroupInputSchema = (isGroupRequired = false) =>
  z.object({
    name: requiredString(),
    parentGroupId: isGroupRequired
      ? requiredString()
      : optionalString().transform((value) => value || null),
  });
